/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthApp_shellRouteImport } from './routes/_auth/_app_shell'
import { Route as AuthAuthRedirectRouteImport } from './routes/_auth/auth-redirect'
import { Route as AuthContactRedirectRouteImport } from './routes/_auth/contact-redirect'
import { Route as AuthApp_shellMainNavigationRouteImport } from './routes/_auth/_app_shell/_main-navigation'
import { Route as AuthApp_shellSettingsNavigationRouteImport } from './routes/_auth/_app_shell/_settings-navigation'
import { Route as AuthApp_shellTicketNavigationRouteImport } from './routes/_auth/_app_shell/_ticket-navigation'
import { Route as AuthApp_shellCreateGroupActionRouteImport } from './routes/_auth/_app_shell/create-group-action'
import { Route as AuthApp_shellMainNavigationIndexRouteImport } from './routes/_auth/_app_shell/_main-navigation/index'
import { Route as AuthApp_shellMainNavigationContactContactIdRouteImport } from './routes/_auth/_app_shell/_main-navigation/contact/$contactId'
import { Route as AuthApp_shellMainNavigationGroupActionGroupActionIdRouteImport } from './routes/_auth/_app_shell/_main-navigation/group-action/$groupActionId'
import { Route as AuthApp_shellMainNavigationGroupActionsIndexRouteImport } from './routes/_auth/_app_shell/_main-navigation/group-actions/index'
import { Route as AuthApp_shellMainNavigationOrderOrderIdRouteImport } from './routes/_auth/_app_shell/_main-navigation/order/$orderId'
import { Route as AuthApp_shellMainNavigationOrdersIndexRouteImport } from './routes/_auth/_app_shell/_main-navigation/orders/index'
import { Route as AuthApp_shellMainNavigationSaleSaleIdRouteImport } from './routes/_auth/_app_shell/_main-navigation/sale/$saleId'
import { Route as AuthApp_shellMainNavigationSearchIndexRouteImport } from './routes/_auth/_app_shell/_main-navigation/search/index'
import { Route as AuthApp_shellMainNavigationTicketsAllRouteImport } from './routes/_auth/_app_shell/_main-navigation/tickets/all'
import { Route as AuthApp_shellMainNavigationTicketsDoneRouteImport } from './routes/_auth/_app_shell/_main-navigation/tickets/done'
import { Route as AuthApp_shellMainNavigationTicketsInvestigatingRouteImport } from './routes/_auth/_app_shell/_main-navigation/tickets/investigating'
import { Route as AuthApp_shellMainNavigationTicketsNeedsFirstResponseRouteImport } from './routes/_auth/_app_shell/_main-navigation/tickets/needs-first-response'
import { Route as AuthApp_shellMainNavigationTicketsNeedsNextResponseRouteImport } from './routes/_auth/_app_shell/_main-navigation/tickets/needs-next-response'
import { Route as AuthApp_shellMainNavigationTicketsPausedForLaterRouteImport } from './routes/_auth/_app_shell/_main-navigation/tickets/paused-for-later'
import { Route as AuthApp_shellMainNavigationTicketsSnoozedRouteImport } from './routes/_auth/_app_shell/_main-navigation/tickets/snoozed'
import { Route as AuthApp_shellMainNavigationTicketsTodoRouteImport } from './routes/_auth/_app_shell/_main-navigation/tickets/todo'
import { Route as AuthApp_shellMainNavigationTicketsUnassignedRouteImport } from './routes/_auth/_app_shell/_main-navigation/tickets/unassigned'
import { Route as AuthApp_shellMainNavigationTicketsWaitingForContactRouteImport } from './routes/_auth/_app_shell/_main-navigation/tickets/waiting-for-contact'
import { Route as AuthApp_shellMainNavigationTicketsWaitingForSupplierRouteImport } from './routes/_auth/_app_shell/_main-navigation/tickets/waiting-for-supplier'
import { Route as AuthApp_shellMainNavigationTicketsYoursRouteImport } from './routes/_auth/_app_shell/_main-navigation/tickets/yours'
import { Route as AuthApp_shellMainNavigationViewViewIdRouteImport } from './routes/_auth/_app_shell/_main-navigation/view/$viewId'
import { Route as AuthApp_shellMainNavigationViewsIndexRouteImport } from './routes/_auth/_app_shell/_main-navigation/views/index'
import { Route as AuthApp_shellMainNavigationViewsAddRouteImport } from './routes/_auth/_app_shell/_main-navigation/views/add'
import { Route as AuthApp_shellSettingsNavigationSettingsIndexRouteImport } from './routes/_auth/_app_shell/_settings-navigation/settings/index'
import { Route as AuthApp_shellSettingsNavigationSettingsPreferencesRouteImport } from './routes/_auth/_app_shell/_settings-navigation/settings/preferences'
import { Route as AuthApp_shellSettingsNavigationSettingsProfileRouteImport } from './routes/_auth/_app_shell/_settings-navigation/settings/profile'
import { Route as AuthApp_shellTicketNavigationTicketTicketIdRouteImport } from './routes/_auth/_app_shell/_ticket-navigation/ticket/$ticketId'
import { Route as AuthApp_shellSettingsNavigationSettingsMemberMemberIdRouteImport } from './routes/_auth/_app_shell/_settings-navigation/settings/member/$memberId'
import { Route as AuthApp_shellSettingsNavigationSettingsMembersIndexRouteImport } from './routes/_auth/_app_shell/_settings-navigation/settings/members/index'
import { Route as AuthApp_shellSettingsNavigationSettingsSnippetTagSnippetTagIdRouteImport } from './routes/_auth/_app_shell/_settings-navigation/settings/snippet-tag/$snippetTagId'
import { Route as AuthApp_shellSettingsNavigationSettingsSnippetTagsIndexRouteImport } from './routes/_auth/_app_shell/_settings-navigation/settings/snippet-tags/index'
import { Route as AuthApp_shellSettingsNavigationSettingsSnippetTagsAddRouteImport } from './routes/_auth/_app_shell/_settings-navigation/settings/snippet-tags/add'
import { Route as AuthApp_shellSettingsNavigationSettingsSnippetSnippetIdRouteImport } from './routes/_auth/_app_shell/_settings-navigation/settings/snippet/$snippetId'
import { Route as AuthApp_shellSettingsNavigationSettingsSnippetsIndexRouteImport } from './routes/_auth/_app_shell/_settings-navigation/settings/snippets/index'
import { Route as AuthApp_shellSettingsNavigationSettingsSnippetsAddRouteImport } from './routes/_auth/_app_shell/_settings-navigation/settings/snippets/add'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthApp_shellRoute = AuthApp_shellRouteImport.update({
  id: '/_app_shell',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthRedirectRoute = AuthAuthRedirectRouteImport.update({
  id: '/auth-redirect',
  path: '/auth-redirect',
  getParentRoute: () => AuthRoute,
} as any)
const AuthContactRedirectRoute = AuthContactRedirectRouteImport.update({
  id: '/contact-redirect',
  path: '/contact-redirect',
  getParentRoute: () => AuthRoute,
} as any)
const AuthApp_shellMainNavigationRoute =
  AuthApp_shellMainNavigationRouteImport.update({
    id: '/_main-navigation',
    getParentRoute: () => AuthApp_shellRoute,
  } as any)
const AuthApp_shellSettingsNavigationRoute =
  AuthApp_shellSettingsNavigationRouteImport.update({
    id: '/_settings-navigation',
    getParentRoute: () => AuthApp_shellRoute,
  } as any)
const AuthApp_shellTicketNavigationRoute =
  AuthApp_shellTicketNavigationRouteImport.update({
    id: '/_ticket-navigation',
    getParentRoute: () => AuthApp_shellRoute,
  } as any)
const AuthApp_shellCreateGroupActionRoute =
  AuthApp_shellCreateGroupActionRouteImport.update({
    id: '/create-group-action',
    path: '/create-group-action',
    getParentRoute: () => AuthApp_shellRoute,
  } as any)
const AuthApp_shellMainNavigationIndexRoute =
  AuthApp_shellMainNavigationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationContactContactIdRoute =
  AuthApp_shellMainNavigationContactContactIdRouteImport.update({
    id: '/contact/$contactId',
    path: '/contact/$contactId',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationGroupActionGroupActionIdRoute =
  AuthApp_shellMainNavigationGroupActionGroupActionIdRouteImport.update({
    id: '/group-action/$groupActionId',
    path: '/group-action/$groupActionId',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationGroupActionsIndexRoute =
  AuthApp_shellMainNavigationGroupActionsIndexRouteImport.update({
    id: '/group-actions/',
    path: '/group-actions/',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationOrderOrderIdRoute =
  AuthApp_shellMainNavigationOrderOrderIdRouteImport.update({
    id: '/order/$orderId',
    path: '/order/$orderId',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationOrdersIndexRoute =
  AuthApp_shellMainNavigationOrdersIndexRouteImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationSaleSaleIdRoute =
  AuthApp_shellMainNavigationSaleSaleIdRouteImport.update({
    id: '/sale/$saleId',
    path: '/sale/$saleId',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationSearchIndexRoute =
  AuthApp_shellMainNavigationSearchIndexRouteImport.update({
    id: '/search/',
    path: '/search/',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationTicketsAllRoute =
  AuthApp_shellMainNavigationTicketsAllRouteImport.update({
    id: '/tickets/all',
    path: '/tickets/all',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationTicketsDoneRoute =
  AuthApp_shellMainNavigationTicketsDoneRouteImport.update({
    id: '/tickets/done',
    path: '/tickets/done',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationTicketsInvestigatingRoute =
  AuthApp_shellMainNavigationTicketsInvestigatingRouteImport.update({
    id: '/tickets/investigating',
    path: '/tickets/investigating',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationTicketsNeedsFirstResponseRoute =
  AuthApp_shellMainNavigationTicketsNeedsFirstResponseRouteImport.update({
    id: '/tickets/needs-first-response',
    path: '/tickets/needs-first-response',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationTicketsNeedsNextResponseRoute =
  AuthApp_shellMainNavigationTicketsNeedsNextResponseRouteImport.update({
    id: '/tickets/needs-next-response',
    path: '/tickets/needs-next-response',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationTicketsPausedForLaterRoute =
  AuthApp_shellMainNavigationTicketsPausedForLaterRouteImport.update({
    id: '/tickets/paused-for-later',
    path: '/tickets/paused-for-later',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationTicketsSnoozedRoute =
  AuthApp_shellMainNavigationTicketsSnoozedRouteImport.update({
    id: '/tickets/snoozed',
    path: '/tickets/snoozed',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationTicketsTodoRoute =
  AuthApp_shellMainNavigationTicketsTodoRouteImport.update({
    id: '/tickets/todo',
    path: '/tickets/todo',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationTicketsUnassignedRoute =
  AuthApp_shellMainNavigationTicketsUnassignedRouteImport.update({
    id: '/tickets/unassigned',
    path: '/tickets/unassigned',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationTicketsWaitingForContactRoute =
  AuthApp_shellMainNavigationTicketsWaitingForContactRouteImport.update({
    id: '/tickets/waiting-for-contact',
    path: '/tickets/waiting-for-contact',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationTicketsWaitingForSupplierRoute =
  AuthApp_shellMainNavigationTicketsWaitingForSupplierRouteImport.update({
    id: '/tickets/waiting-for-supplier',
    path: '/tickets/waiting-for-supplier',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationTicketsYoursRoute =
  AuthApp_shellMainNavigationTicketsYoursRouteImport.update({
    id: '/tickets/yours',
    path: '/tickets/yours',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationViewViewIdRoute =
  AuthApp_shellMainNavigationViewViewIdRouteImport.update({
    id: '/view/$viewId',
    path: '/view/$viewId',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationViewsIndexRoute =
  AuthApp_shellMainNavigationViewsIndexRouteImport.update({
    id: '/views/',
    path: '/views/',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellMainNavigationViewsAddRoute =
  AuthApp_shellMainNavigationViewsAddRouteImport.update({
    id: '/views/add',
    path: '/views/add',
    getParentRoute: () => AuthApp_shellMainNavigationRoute,
  } as any)
const AuthApp_shellSettingsNavigationSettingsIndexRoute =
  AuthApp_shellSettingsNavigationSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthApp_shellSettingsNavigationRoute,
  } as any)
const AuthApp_shellSettingsNavigationSettingsPreferencesRoute =
  AuthApp_shellSettingsNavigationSettingsPreferencesRouteImport.update({
    id: '/settings/preferences',
    path: '/settings/preferences',
    getParentRoute: () => AuthApp_shellSettingsNavigationRoute,
  } as any)
const AuthApp_shellSettingsNavigationSettingsProfileRoute =
  AuthApp_shellSettingsNavigationSettingsProfileRouteImport.update({
    id: '/settings/profile',
    path: '/settings/profile',
    getParentRoute: () => AuthApp_shellSettingsNavigationRoute,
  } as any)
const AuthApp_shellTicketNavigationTicketTicketIdRoute =
  AuthApp_shellTicketNavigationTicketTicketIdRouteImport.update({
    id: '/ticket/$ticketId',
    path: '/ticket/$ticketId',
    getParentRoute: () => AuthApp_shellTicketNavigationRoute,
  } as any)
const AuthApp_shellSettingsNavigationSettingsMemberMemberIdRoute =
  AuthApp_shellSettingsNavigationSettingsMemberMemberIdRouteImport.update({
    id: '/settings/member/$memberId',
    path: '/settings/member/$memberId',
    getParentRoute: () => AuthApp_shellSettingsNavigationRoute,
  } as any)
const AuthApp_shellSettingsNavigationSettingsMembersIndexRoute =
  AuthApp_shellSettingsNavigationSettingsMembersIndexRouteImport.update({
    id: '/settings/members/',
    path: '/settings/members/',
    getParentRoute: () => AuthApp_shellSettingsNavigationRoute,
  } as any)
const AuthApp_shellSettingsNavigationSettingsSnippetTagSnippetTagIdRoute =
  AuthApp_shellSettingsNavigationSettingsSnippetTagSnippetTagIdRouteImport.update(
    {
      id: '/settings/snippet-tag/$snippetTagId',
      path: '/settings/snippet-tag/$snippetTagId',
      getParentRoute: () => AuthApp_shellSettingsNavigationRoute,
    } as any,
  )
const AuthApp_shellSettingsNavigationSettingsSnippetTagsIndexRoute =
  AuthApp_shellSettingsNavigationSettingsSnippetTagsIndexRouteImport.update({
    id: '/settings/snippet-tags/',
    path: '/settings/snippet-tags/',
    getParentRoute: () => AuthApp_shellSettingsNavigationRoute,
  } as any)
const AuthApp_shellSettingsNavigationSettingsSnippetTagsAddRoute =
  AuthApp_shellSettingsNavigationSettingsSnippetTagsAddRouteImport.update({
    id: '/settings/snippet-tags/add',
    path: '/settings/snippet-tags/add',
    getParentRoute: () => AuthApp_shellSettingsNavigationRoute,
  } as any)
const AuthApp_shellSettingsNavigationSettingsSnippetSnippetIdRoute =
  AuthApp_shellSettingsNavigationSettingsSnippetSnippetIdRouteImport.update({
    id: '/settings/snippet/$snippetId',
    path: '/settings/snippet/$snippetId',
    getParentRoute: () => AuthApp_shellSettingsNavigationRoute,
  } as any)
const AuthApp_shellSettingsNavigationSettingsSnippetsIndexRoute =
  AuthApp_shellSettingsNavigationSettingsSnippetsIndexRouteImport.update({
    id: '/settings/snippets/',
    path: '/settings/snippets/',
    getParentRoute: () => AuthApp_shellSettingsNavigationRoute,
  } as any)
const AuthApp_shellSettingsNavigationSettingsSnippetsAddRoute =
  AuthApp_shellSettingsNavigationSettingsSnippetsAddRouteImport.update({
    id: '/settings/snippets/add',
    path: '/settings/snippets/add',
    getParentRoute: () => AuthApp_shellSettingsNavigationRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthApp_shellMainNavigationIndexRoute
  '/auth-redirect': typeof AuthAuthRedirectRoute
  '/contact-redirect': typeof AuthContactRedirectRoute
  '/create-group-action': typeof AuthApp_shellCreateGroupActionRoute
  '/contact/$contactId': typeof AuthApp_shellMainNavigationContactContactIdRoute
  '/group-action/$groupActionId': typeof AuthApp_shellMainNavigationGroupActionGroupActionIdRoute
  '/order/$orderId': typeof AuthApp_shellMainNavigationOrderOrderIdRoute
  '/sale/$saleId': typeof AuthApp_shellMainNavigationSaleSaleIdRoute
  '/tickets/all': typeof AuthApp_shellMainNavigationTicketsAllRoute
  '/tickets/done': typeof AuthApp_shellMainNavigationTicketsDoneRoute
  '/tickets/investigating': typeof AuthApp_shellMainNavigationTicketsInvestigatingRoute
  '/tickets/needs-first-response': typeof AuthApp_shellMainNavigationTicketsNeedsFirstResponseRoute
  '/tickets/needs-next-response': typeof AuthApp_shellMainNavigationTicketsNeedsNextResponseRoute
  '/tickets/paused-for-later': typeof AuthApp_shellMainNavigationTicketsPausedForLaterRoute
  '/tickets/snoozed': typeof AuthApp_shellMainNavigationTicketsSnoozedRoute
  '/tickets/todo': typeof AuthApp_shellMainNavigationTicketsTodoRoute
  '/tickets/unassigned': typeof AuthApp_shellMainNavigationTicketsUnassignedRoute
  '/tickets/waiting-for-contact': typeof AuthApp_shellMainNavigationTicketsWaitingForContactRoute
  '/tickets/waiting-for-supplier': typeof AuthApp_shellMainNavigationTicketsWaitingForSupplierRoute
  '/tickets/yours': typeof AuthApp_shellMainNavigationTicketsYoursRoute
  '/view/$viewId': typeof AuthApp_shellMainNavigationViewViewIdRoute
  '/views/add': typeof AuthApp_shellMainNavigationViewsAddRoute
  '/settings/preferences': typeof AuthApp_shellSettingsNavigationSettingsPreferencesRoute
  '/settings/profile': typeof AuthApp_shellSettingsNavigationSettingsProfileRoute
  '/ticket/$ticketId': typeof AuthApp_shellTicketNavigationTicketTicketIdRoute
  '/group-actions/': typeof AuthApp_shellMainNavigationGroupActionsIndexRoute
  '/orders/': typeof AuthApp_shellMainNavigationOrdersIndexRoute
  '/search/': typeof AuthApp_shellMainNavigationSearchIndexRoute
  '/views/': typeof AuthApp_shellMainNavigationViewsIndexRoute
  '/settings/': typeof AuthApp_shellSettingsNavigationSettingsIndexRoute
  '/settings/member/$memberId': typeof AuthApp_shellSettingsNavigationSettingsMemberMemberIdRoute
  '/settings/snippet-tag/$snippetTagId': typeof AuthApp_shellSettingsNavigationSettingsSnippetTagSnippetTagIdRoute
  '/settings/snippet-tags/add': typeof AuthApp_shellSettingsNavigationSettingsSnippetTagsAddRoute
  '/settings/snippet/$snippetId': typeof AuthApp_shellSettingsNavigationSettingsSnippetSnippetIdRoute
  '/settings/snippets/add': typeof AuthApp_shellSettingsNavigationSettingsSnippetsAddRoute
  '/settings/members/': typeof AuthApp_shellSettingsNavigationSettingsMembersIndexRoute
  '/settings/snippet-tags/': typeof AuthApp_shellSettingsNavigationSettingsSnippetTagsIndexRoute
  '/settings/snippets/': typeof AuthApp_shellSettingsNavigationSettingsSnippetsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthApp_shellMainNavigationIndexRoute
  '/auth-redirect': typeof AuthAuthRedirectRoute
  '/contact-redirect': typeof AuthContactRedirectRoute
  '/create-group-action': typeof AuthApp_shellCreateGroupActionRoute
  '/contact/$contactId': typeof AuthApp_shellMainNavigationContactContactIdRoute
  '/group-action/$groupActionId': typeof AuthApp_shellMainNavigationGroupActionGroupActionIdRoute
  '/order/$orderId': typeof AuthApp_shellMainNavigationOrderOrderIdRoute
  '/sale/$saleId': typeof AuthApp_shellMainNavigationSaleSaleIdRoute
  '/tickets/all': typeof AuthApp_shellMainNavigationTicketsAllRoute
  '/tickets/done': typeof AuthApp_shellMainNavigationTicketsDoneRoute
  '/tickets/investigating': typeof AuthApp_shellMainNavigationTicketsInvestigatingRoute
  '/tickets/needs-first-response': typeof AuthApp_shellMainNavigationTicketsNeedsFirstResponseRoute
  '/tickets/needs-next-response': typeof AuthApp_shellMainNavigationTicketsNeedsNextResponseRoute
  '/tickets/paused-for-later': typeof AuthApp_shellMainNavigationTicketsPausedForLaterRoute
  '/tickets/snoozed': typeof AuthApp_shellMainNavigationTicketsSnoozedRoute
  '/tickets/todo': typeof AuthApp_shellMainNavigationTicketsTodoRoute
  '/tickets/unassigned': typeof AuthApp_shellMainNavigationTicketsUnassignedRoute
  '/tickets/waiting-for-contact': typeof AuthApp_shellMainNavigationTicketsWaitingForContactRoute
  '/tickets/waiting-for-supplier': typeof AuthApp_shellMainNavigationTicketsWaitingForSupplierRoute
  '/tickets/yours': typeof AuthApp_shellMainNavigationTicketsYoursRoute
  '/view/$viewId': typeof AuthApp_shellMainNavigationViewViewIdRoute
  '/views/add': typeof AuthApp_shellMainNavigationViewsAddRoute
  '/settings/preferences': typeof AuthApp_shellSettingsNavigationSettingsPreferencesRoute
  '/settings/profile': typeof AuthApp_shellSettingsNavigationSettingsProfileRoute
  '/ticket/$ticketId': typeof AuthApp_shellTicketNavigationTicketTicketIdRoute
  '/group-actions': typeof AuthApp_shellMainNavigationGroupActionsIndexRoute
  '/orders': typeof AuthApp_shellMainNavigationOrdersIndexRoute
  '/search': typeof AuthApp_shellMainNavigationSearchIndexRoute
  '/views': typeof AuthApp_shellMainNavigationViewsIndexRoute
  '/settings': typeof AuthApp_shellSettingsNavigationSettingsIndexRoute
  '/settings/member/$memberId': typeof AuthApp_shellSettingsNavigationSettingsMemberMemberIdRoute
  '/settings/snippet-tag/$snippetTagId': typeof AuthApp_shellSettingsNavigationSettingsSnippetTagSnippetTagIdRoute
  '/settings/snippet-tags/add': typeof AuthApp_shellSettingsNavigationSettingsSnippetTagsAddRoute
  '/settings/snippet/$snippetId': typeof AuthApp_shellSettingsNavigationSettingsSnippetSnippetIdRoute
  '/settings/snippets/add': typeof AuthApp_shellSettingsNavigationSettingsSnippetsAddRoute
  '/settings/members': typeof AuthApp_shellSettingsNavigationSettingsMembersIndexRoute
  '/settings/snippet-tags': typeof AuthApp_shellSettingsNavigationSettingsSnippetTagsIndexRoute
  '/settings/snippets': typeof AuthApp_shellSettingsNavigationSettingsSnippetsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_auth/_app_shell': typeof AuthApp_shellRouteWithChildren
  '/_auth/auth-redirect': typeof AuthAuthRedirectRoute
  '/_auth/contact-redirect': typeof AuthContactRedirectRoute
  '/_auth/_app_shell/_main-navigation': typeof AuthApp_shellMainNavigationRouteWithChildren
  '/_auth/_app_shell/_settings-navigation': typeof AuthApp_shellSettingsNavigationRouteWithChildren
  '/_auth/_app_shell/_ticket-navigation': typeof AuthApp_shellTicketNavigationRouteWithChildren
  '/_auth/_app_shell/create-group-action': typeof AuthApp_shellCreateGroupActionRoute
  '/_auth/_app_shell/_main-navigation/': typeof AuthApp_shellMainNavigationIndexRoute
  '/_auth/_app_shell/_main-navigation/contact/$contactId': typeof AuthApp_shellMainNavigationContactContactIdRoute
  '/_auth/_app_shell/_main-navigation/group-action/$groupActionId': typeof AuthApp_shellMainNavigationGroupActionGroupActionIdRoute
  '/_auth/_app_shell/_main-navigation/order/$orderId': typeof AuthApp_shellMainNavigationOrderOrderIdRoute
  '/_auth/_app_shell/_main-navigation/sale/$saleId': typeof AuthApp_shellMainNavigationSaleSaleIdRoute
  '/_auth/_app_shell/_main-navigation/tickets/all': typeof AuthApp_shellMainNavigationTicketsAllRoute
  '/_auth/_app_shell/_main-navigation/tickets/done': typeof AuthApp_shellMainNavigationTicketsDoneRoute
  '/_auth/_app_shell/_main-navigation/tickets/investigating': typeof AuthApp_shellMainNavigationTicketsInvestigatingRoute
  '/_auth/_app_shell/_main-navigation/tickets/needs-first-response': typeof AuthApp_shellMainNavigationTicketsNeedsFirstResponseRoute
  '/_auth/_app_shell/_main-navigation/tickets/needs-next-response': typeof AuthApp_shellMainNavigationTicketsNeedsNextResponseRoute
  '/_auth/_app_shell/_main-navigation/tickets/paused-for-later': typeof AuthApp_shellMainNavigationTicketsPausedForLaterRoute
  '/_auth/_app_shell/_main-navigation/tickets/snoozed': typeof AuthApp_shellMainNavigationTicketsSnoozedRoute
  '/_auth/_app_shell/_main-navigation/tickets/todo': typeof AuthApp_shellMainNavigationTicketsTodoRoute
  '/_auth/_app_shell/_main-navigation/tickets/unassigned': typeof AuthApp_shellMainNavigationTicketsUnassignedRoute
  '/_auth/_app_shell/_main-navigation/tickets/waiting-for-contact': typeof AuthApp_shellMainNavigationTicketsWaitingForContactRoute
  '/_auth/_app_shell/_main-navigation/tickets/waiting-for-supplier': typeof AuthApp_shellMainNavigationTicketsWaitingForSupplierRoute
  '/_auth/_app_shell/_main-navigation/tickets/yours': typeof AuthApp_shellMainNavigationTicketsYoursRoute
  '/_auth/_app_shell/_main-navigation/view/$viewId': typeof AuthApp_shellMainNavigationViewViewIdRoute
  '/_auth/_app_shell/_main-navigation/views/add': typeof AuthApp_shellMainNavigationViewsAddRoute
  '/_auth/_app_shell/_settings-navigation/settings/preferences': typeof AuthApp_shellSettingsNavigationSettingsPreferencesRoute
  '/_auth/_app_shell/_settings-navigation/settings/profile': typeof AuthApp_shellSettingsNavigationSettingsProfileRoute
  '/_auth/_app_shell/_ticket-navigation/ticket/$ticketId': typeof AuthApp_shellTicketNavigationTicketTicketIdRoute
  '/_auth/_app_shell/_main-navigation/group-actions/': typeof AuthApp_shellMainNavigationGroupActionsIndexRoute
  '/_auth/_app_shell/_main-navigation/orders/': typeof AuthApp_shellMainNavigationOrdersIndexRoute
  '/_auth/_app_shell/_main-navigation/search/': typeof AuthApp_shellMainNavigationSearchIndexRoute
  '/_auth/_app_shell/_main-navigation/views/': typeof AuthApp_shellMainNavigationViewsIndexRoute
  '/_auth/_app_shell/_settings-navigation/settings/': typeof AuthApp_shellSettingsNavigationSettingsIndexRoute
  '/_auth/_app_shell/_settings-navigation/settings/member/$memberId': typeof AuthApp_shellSettingsNavigationSettingsMemberMemberIdRoute
  '/_auth/_app_shell/_settings-navigation/settings/snippet-tag/$snippetTagId': typeof AuthApp_shellSettingsNavigationSettingsSnippetTagSnippetTagIdRoute
  '/_auth/_app_shell/_settings-navigation/settings/snippet-tags/add': typeof AuthApp_shellSettingsNavigationSettingsSnippetTagsAddRoute
  '/_auth/_app_shell/_settings-navigation/settings/snippet/$snippetId': typeof AuthApp_shellSettingsNavigationSettingsSnippetSnippetIdRoute
  '/_auth/_app_shell/_settings-navigation/settings/snippets/add': typeof AuthApp_shellSettingsNavigationSettingsSnippetsAddRoute
  '/_auth/_app_shell/_settings-navigation/settings/members/': typeof AuthApp_shellSettingsNavigationSettingsMembersIndexRoute
  '/_auth/_app_shell/_settings-navigation/settings/snippet-tags/': typeof AuthApp_shellSettingsNavigationSettingsSnippetTagsIndexRoute
  '/_auth/_app_shell/_settings-navigation/settings/snippets/': typeof AuthApp_shellSettingsNavigationSettingsSnippetsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth-redirect'
    | '/contact-redirect'
    | '/create-group-action'
    | '/contact/$contactId'
    | '/group-action/$groupActionId'
    | '/order/$orderId'
    | '/sale/$saleId'
    | '/tickets/all'
    | '/tickets/done'
    | '/tickets/investigating'
    | '/tickets/needs-first-response'
    | '/tickets/needs-next-response'
    | '/tickets/paused-for-later'
    | '/tickets/snoozed'
    | '/tickets/todo'
    | '/tickets/unassigned'
    | '/tickets/waiting-for-contact'
    | '/tickets/waiting-for-supplier'
    | '/tickets/yours'
    | '/view/$viewId'
    | '/views/add'
    | '/settings/preferences'
    | '/settings/profile'
    | '/ticket/$ticketId'
    | '/group-actions/'
    | '/orders/'
    | '/search/'
    | '/views/'
    | '/settings/'
    | '/settings/member/$memberId'
    | '/settings/snippet-tag/$snippetTagId'
    | '/settings/snippet-tags/add'
    | '/settings/snippet/$snippetId'
    | '/settings/snippets/add'
    | '/settings/members/'
    | '/settings/snippet-tags/'
    | '/settings/snippets/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth-redirect'
    | '/contact-redirect'
    | '/create-group-action'
    | '/contact/$contactId'
    | '/group-action/$groupActionId'
    | '/order/$orderId'
    | '/sale/$saleId'
    | '/tickets/all'
    | '/tickets/done'
    | '/tickets/investigating'
    | '/tickets/needs-first-response'
    | '/tickets/needs-next-response'
    | '/tickets/paused-for-later'
    | '/tickets/snoozed'
    | '/tickets/todo'
    | '/tickets/unassigned'
    | '/tickets/waiting-for-contact'
    | '/tickets/waiting-for-supplier'
    | '/tickets/yours'
    | '/view/$viewId'
    | '/views/add'
    | '/settings/preferences'
    | '/settings/profile'
    | '/ticket/$ticketId'
    | '/group-actions'
    | '/orders'
    | '/search'
    | '/views'
    | '/settings'
    | '/settings/member/$memberId'
    | '/settings/snippet-tag/$snippetTagId'
    | '/settings/snippet-tags/add'
    | '/settings/snippet/$snippetId'
    | '/settings/snippets/add'
    | '/settings/members'
    | '/settings/snippet-tags'
    | '/settings/snippets'
  id:
    | '__root__'
    | '/_auth'
    | '/_auth/_app_shell'
    | '/_auth/auth-redirect'
    | '/_auth/contact-redirect'
    | '/_auth/_app_shell/_main-navigation'
    | '/_auth/_app_shell/_settings-navigation'
    | '/_auth/_app_shell/_ticket-navigation'
    | '/_auth/_app_shell/create-group-action'
    | '/_auth/_app_shell/_main-navigation/'
    | '/_auth/_app_shell/_main-navigation/contact/$contactId'
    | '/_auth/_app_shell/_main-navigation/group-action/$groupActionId'
    | '/_auth/_app_shell/_main-navigation/order/$orderId'
    | '/_auth/_app_shell/_main-navigation/sale/$saleId'
    | '/_auth/_app_shell/_main-navigation/tickets/all'
    | '/_auth/_app_shell/_main-navigation/tickets/done'
    | '/_auth/_app_shell/_main-navigation/tickets/investigating'
    | '/_auth/_app_shell/_main-navigation/tickets/needs-first-response'
    | '/_auth/_app_shell/_main-navigation/tickets/needs-next-response'
    | '/_auth/_app_shell/_main-navigation/tickets/paused-for-later'
    | '/_auth/_app_shell/_main-navigation/tickets/snoozed'
    | '/_auth/_app_shell/_main-navigation/tickets/todo'
    | '/_auth/_app_shell/_main-navigation/tickets/unassigned'
    | '/_auth/_app_shell/_main-navigation/tickets/waiting-for-contact'
    | '/_auth/_app_shell/_main-navigation/tickets/waiting-for-supplier'
    | '/_auth/_app_shell/_main-navigation/tickets/yours'
    | '/_auth/_app_shell/_main-navigation/view/$viewId'
    | '/_auth/_app_shell/_main-navigation/views/add'
    | '/_auth/_app_shell/_settings-navigation/settings/preferences'
    | '/_auth/_app_shell/_settings-navigation/settings/profile'
    | '/_auth/_app_shell/_ticket-navigation/ticket/$ticketId'
    | '/_auth/_app_shell/_main-navigation/group-actions/'
    | '/_auth/_app_shell/_main-navigation/orders/'
    | '/_auth/_app_shell/_main-navigation/search/'
    | '/_auth/_app_shell/_main-navigation/views/'
    | '/_auth/_app_shell/_settings-navigation/settings/'
    | '/_auth/_app_shell/_settings-navigation/settings/member/$memberId'
    | '/_auth/_app_shell/_settings-navigation/settings/snippet-tag/$snippetTagId'
    | '/_auth/_app_shell/_settings-navigation/settings/snippet-tags/add'
    | '/_auth/_app_shell/_settings-navigation/settings/snippet/$snippetId'
    | '/_auth/_app_shell/_settings-navigation/settings/snippets/add'
    | '/_auth/_app_shell/_settings-navigation/settings/members/'
    | '/_auth/_app_shell/_settings-navigation/settings/snippet-tags/'
    | '/_auth/_app_shell/_settings-navigation/settings/snippets/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_app_shell': {
      id: '/_auth/_app_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthApp_shellRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth-redirect': {
      id: '/_auth/auth-redirect'
      path: '/auth-redirect'
      fullPath: '/auth-redirect'
      preLoaderRoute: typeof AuthAuthRedirectRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/contact-redirect': {
      id: '/_auth/contact-redirect'
      path: '/contact-redirect'
      fullPath: '/contact-redirect'
      preLoaderRoute: typeof AuthContactRedirectRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_app_shell/_main-navigation': {
      id: '/_auth/_app_shell/_main-navigation'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthApp_shellMainNavigationRouteImport
      parentRoute: typeof AuthApp_shellRoute
    }
    '/_auth/_app_shell/_settings-navigation': {
      id: '/_auth/_app_shell/_settings-navigation'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthApp_shellSettingsNavigationRouteImport
      parentRoute: typeof AuthApp_shellRoute
    }
    '/_auth/_app_shell/_ticket-navigation': {
      id: '/_auth/_app_shell/_ticket-navigation'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthApp_shellTicketNavigationRouteImport
      parentRoute: typeof AuthApp_shellRoute
    }
    '/_auth/_app_shell/create-group-action': {
      id: '/_auth/_app_shell/create-group-action'
      path: '/create-group-action'
      fullPath: '/create-group-action'
      preLoaderRoute: typeof AuthApp_shellCreateGroupActionRouteImport
      parentRoute: typeof AuthApp_shellRoute
    }
    '/_auth/_app_shell/_main-navigation/': {
      id: '/_auth/_app_shell/_main-navigation/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthApp_shellMainNavigationIndexRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/contact/$contactId': {
      id: '/_auth/_app_shell/_main-navigation/contact/$contactId'
      path: '/contact/$contactId'
      fullPath: '/contact/$contactId'
      preLoaderRoute: typeof AuthApp_shellMainNavigationContactContactIdRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/group-action/$groupActionId': {
      id: '/_auth/_app_shell/_main-navigation/group-action/$groupActionId'
      path: '/group-action/$groupActionId'
      fullPath: '/group-action/$groupActionId'
      preLoaderRoute: typeof AuthApp_shellMainNavigationGroupActionGroupActionIdRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/group-actions/': {
      id: '/_auth/_app_shell/_main-navigation/group-actions/'
      path: '/group-actions'
      fullPath: '/group-actions/'
      preLoaderRoute: typeof AuthApp_shellMainNavigationGroupActionsIndexRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/order/$orderId': {
      id: '/_auth/_app_shell/_main-navigation/order/$orderId'
      path: '/order/$orderId'
      fullPath: '/order/$orderId'
      preLoaderRoute: typeof AuthApp_shellMainNavigationOrderOrderIdRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/orders/': {
      id: '/_auth/_app_shell/_main-navigation/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AuthApp_shellMainNavigationOrdersIndexRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/sale/$saleId': {
      id: '/_auth/_app_shell/_main-navigation/sale/$saleId'
      path: '/sale/$saleId'
      fullPath: '/sale/$saleId'
      preLoaderRoute: typeof AuthApp_shellMainNavigationSaleSaleIdRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/search/': {
      id: '/_auth/_app_shell/_main-navigation/search/'
      path: '/search'
      fullPath: '/search/'
      preLoaderRoute: typeof AuthApp_shellMainNavigationSearchIndexRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/tickets/all': {
      id: '/_auth/_app_shell/_main-navigation/tickets/all'
      path: '/tickets/all'
      fullPath: '/tickets/all'
      preLoaderRoute: typeof AuthApp_shellMainNavigationTicketsAllRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/tickets/done': {
      id: '/_auth/_app_shell/_main-navigation/tickets/done'
      path: '/tickets/done'
      fullPath: '/tickets/done'
      preLoaderRoute: typeof AuthApp_shellMainNavigationTicketsDoneRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/tickets/investigating': {
      id: '/_auth/_app_shell/_main-navigation/tickets/investigating'
      path: '/tickets/investigating'
      fullPath: '/tickets/investigating'
      preLoaderRoute: typeof AuthApp_shellMainNavigationTicketsInvestigatingRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/tickets/needs-first-response': {
      id: '/_auth/_app_shell/_main-navigation/tickets/needs-first-response'
      path: '/tickets/needs-first-response'
      fullPath: '/tickets/needs-first-response'
      preLoaderRoute: typeof AuthApp_shellMainNavigationTicketsNeedsFirstResponseRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/tickets/needs-next-response': {
      id: '/_auth/_app_shell/_main-navigation/tickets/needs-next-response'
      path: '/tickets/needs-next-response'
      fullPath: '/tickets/needs-next-response'
      preLoaderRoute: typeof AuthApp_shellMainNavigationTicketsNeedsNextResponseRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/tickets/paused-for-later': {
      id: '/_auth/_app_shell/_main-navigation/tickets/paused-for-later'
      path: '/tickets/paused-for-later'
      fullPath: '/tickets/paused-for-later'
      preLoaderRoute: typeof AuthApp_shellMainNavigationTicketsPausedForLaterRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/tickets/snoozed': {
      id: '/_auth/_app_shell/_main-navigation/tickets/snoozed'
      path: '/tickets/snoozed'
      fullPath: '/tickets/snoozed'
      preLoaderRoute: typeof AuthApp_shellMainNavigationTicketsSnoozedRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/tickets/todo': {
      id: '/_auth/_app_shell/_main-navigation/tickets/todo'
      path: '/tickets/todo'
      fullPath: '/tickets/todo'
      preLoaderRoute: typeof AuthApp_shellMainNavigationTicketsTodoRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/tickets/unassigned': {
      id: '/_auth/_app_shell/_main-navigation/tickets/unassigned'
      path: '/tickets/unassigned'
      fullPath: '/tickets/unassigned'
      preLoaderRoute: typeof AuthApp_shellMainNavigationTicketsUnassignedRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/tickets/waiting-for-contact': {
      id: '/_auth/_app_shell/_main-navigation/tickets/waiting-for-contact'
      path: '/tickets/waiting-for-contact'
      fullPath: '/tickets/waiting-for-contact'
      preLoaderRoute: typeof AuthApp_shellMainNavigationTicketsWaitingForContactRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/tickets/waiting-for-supplier': {
      id: '/_auth/_app_shell/_main-navigation/tickets/waiting-for-supplier'
      path: '/tickets/waiting-for-supplier'
      fullPath: '/tickets/waiting-for-supplier'
      preLoaderRoute: typeof AuthApp_shellMainNavigationTicketsWaitingForSupplierRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/tickets/yours': {
      id: '/_auth/_app_shell/_main-navigation/tickets/yours'
      path: '/tickets/yours'
      fullPath: '/tickets/yours'
      preLoaderRoute: typeof AuthApp_shellMainNavigationTicketsYoursRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/view/$viewId': {
      id: '/_auth/_app_shell/_main-navigation/view/$viewId'
      path: '/view/$viewId'
      fullPath: '/view/$viewId'
      preLoaderRoute: typeof AuthApp_shellMainNavigationViewViewIdRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/views/': {
      id: '/_auth/_app_shell/_main-navigation/views/'
      path: '/views'
      fullPath: '/views/'
      preLoaderRoute: typeof AuthApp_shellMainNavigationViewsIndexRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_main-navigation/views/add': {
      id: '/_auth/_app_shell/_main-navigation/views/add'
      path: '/views/add'
      fullPath: '/views/add'
      preLoaderRoute: typeof AuthApp_shellMainNavigationViewsAddRouteImport
      parentRoute: typeof AuthApp_shellMainNavigationRoute
    }
    '/_auth/_app_shell/_settings-navigation/settings/': {
      id: '/_auth/_app_shell/_settings-navigation/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthApp_shellSettingsNavigationSettingsIndexRouteImport
      parentRoute: typeof AuthApp_shellSettingsNavigationRoute
    }
    '/_auth/_app_shell/_settings-navigation/settings/preferences': {
      id: '/_auth/_app_shell/_settings-navigation/settings/preferences'
      path: '/settings/preferences'
      fullPath: '/settings/preferences'
      preLoaderRoute: typeof AuthApp_shellSettingsNavigationSettingsPreferencesRouteImport
      parentRoute: typeof AuthApp_shellSettingsNavigationRoute
    }
    '/_auth/_app_shell/_settings-navigation/settings/profile': {
      id: '/_auth/_app_shell/_settings-navigation/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthApp_shellSettingsNavigationSettingsProfileRouteImport
      parentRoute: typeof AuthApp_shellSettingsNavigationRoute
    }
    '/_auth/_app_shell/_ticket-navigation/ticket/$ticketId': {
      id: '/_auth/_app_shell/_ticket-navigation/ticket/$ticketId'
      path: '/ticket/$ticketId'
      fullPath: '/ticket/$ticketId'
      preLoaderRoute: typeof AuthApp_shellTicketNavigationTicketTicketIdRouteImport
      parentRoute: typeof AuthApp_shellTicketNavigationRoute
    }
    '/_auth/_app_shell/_settings-navigation/settings/member/$memberId': {
      id: '/_auth/_app_shell/_settings-navigation/settings/member/$memberId'
      path: '/settings/member/$memberId'
      fullPath: '/settings/member/$memberId'
      preLoaderRoute: typeof AuthApp_shellSettingsNavigationSettingsMemberMemberIdRouteImport
      parentRoute: typeof AuthApp_shellSettingsNavigationRoute
    }
    '/_auth/_app_shell/_settings-navigation/settings/members/': {
      id: '/_auth/_app_shell/_settings-navigation/settings/members/'
      path: '/settings/members'
      fullPath: '/settings/members/'
      preLoaderRoute: typeof AuthApp_shellSettingsNavigationSettingsMembersIndexRouteImport
      parentRoute: typeof AuthApp_shellSettingsNavigationRoute
    }
    '/_auth/_app_shell/_settings-navigation/settings/snippet-tag/$snippetTagId': {
      id: '/_auth/_app_shell/_settings-navigation/settings/snippet-tag/$snippetTagId'
      path: '/settings/snippet-tag/$snippetTagId'
      fullPath: '/settings/snippet-tag/$snippetTagId'
      preLoaderRoute: typeof AuthApp_shellSettingsNavigationSettingsSnippetTagSnippetTagIdRouteImport
      parentRoute: typeof AuthApp_shellSettingsNavigationRoute
    }
    '/_auth/_app_shell/_settings-navigation/settings/snippet-tags/': {
      id: '/_auth/_app_shell/_settings-navigation/settings/snippet-tags/'
      path: '/settings/snippet-tags'
      fullPath: '/settings/snippet-tags/'
      preLoaderRoute: typeof AuthApp_shellSettingsNavigationSettingsSnippetTagsIndexRouteImport
      parentRoute: typeof AuthApp_shellSettingsNavigationRoute
    }
    '/_auth/_app_shell/_settings-navigation/settings/snippet-tags/add': {
      id: '/_auth/_app_shell/_settings-navigation/settings/snippet-tags/add'
      path: '/settings/snippet-tags/add'
      fullPath: '/settings/snippet-tags/add'
      preLoaderRoute: typeof AuthApp_shellSettingsNavigationSettingsSnippetTagsAddRouteImport
      parentRoute: typeof AuthApp_shellSettingsNavigationRoute
    }
    '/_auth/_app_shell/_settings-navigation/settings/snippet/$snippetId': {
      id: '/_auth/_app_shell/_settings-navigation/settings/snippet/$snippetId'
      path: '/settings/snippet/$snippetId'
      fullPath: '/settings/snippet/$snippetId'
      preLoaderRoute: typeof AuthApp_shellSettingsNavigationSettingsSnippetSnippetIdRouteImport
      parentRoute: typeof AuthApp_shellSettingsNavigationRoute
    }
    '/_auth/_app_shell/_settings-navigation/settings/snippets/': {
      id: '/_auth/_app_shell/_settings-navigation/settings/snippets/'
      path: '/settings/snippets'
      fullPath: '/settings/snippets/'
      preLoaderRoute: typeof AuthApp_shellSettingsNavigationSettingsSnippetsIndexRouteImport
      parentRoute: typeof AuthApp_shellSettingsNavigationRoute
    }
    '/_auth/_app_shell/_settings-navigation/settings/snippets/add': {
      id: '/_auth/_app_shell/_settings-navigation/settings/snippets/add'
      path: '/settings/snippets/add'
      fullPath: '/settings/snippets/add'
      preLoaderRoute: typeof AuthApp_shellSettingsNavigationSettingsSnippetsAddRouteImport
      parentRoute: typeof AuthApp_shellSettingsNavigationRoute
    }
  }
}

interface AuthApp_shellMainNavigationRouteChildren {
  AuthApp_shellMainNavigationIndexRoute: typeof AuthApp_shellMainNavigationIndexRoute
  AuthApp_shellMainNavigationContactContactIdRoute: typeof AuthApp_shellMainNavigationContactContactIdRoute
  AuthApp_shellMainNavigationGroupActionGroupActionIdRoute: typeof AuthApp_shellMainNavigationGroupActionGroupActionIdRoute
  AuthApp_shellMainNavigationOrderOrderIdRoute: typeof AuthApp_shellMainNavigationOrderOrderIdRoute
  AuthApp_shellMainNavigationSaleSaleIdRoute: typeof AuthApp_shellMainNavigationSaleSaleIdRoute
  AuthApp_shellMainNavigationTicketsAllRoute: typeof AuthApp_shellMainNavigationTicketsAllRoute
  AuthApp_shellMainNavigationTicketsDoneRoute: typeof AuthApp_shellMainNavigationTicketsDoneRoute
  AuthApp_shellMainNavigationTicketsInvestigatingRoute: typeof AuthApp_shellMainNavigationTicketsInvestigatingRoute
  AuthApp_shellMainNavigationTicketsNeedsFirstResponseRoute: typeof AuthApp_shellMainNavigationTicketsNeedsFirstResponseRoute
  AuthApp_shellMainNavigationTicketsNeedsNextResponseRoute: typeof AuthApp_shellMainNavigationTicketsNeedsNextResponseRoute
  AuthApp_shellMainNavigationTicketsPausedForLaterRoute: typeof AuthApp_shellMainNavigationTicketsPausedForLaterRoute
  AuthApp_shellMainNavigationTicketsSnoozedRoute: typeof AuthApp_shellMainNavigationTicketsSnoozedRoute
  AuthApp_shellMainNavigationTicketsTodoRoute: typeof AuthApp_shellMainNavigationTicketsTodoRoute
  AuthApp_shellMainNavigationTicketsUnassignedRoute: typeof AuthApp_shellMainNavigationTicketsUnassignedRoute
  AuthApp_shellMainNavigationTicketsWaitingForContactRoute: typeof AuthApp_shellMainNavigationTicketsWaitingForContactRoute
  AuthApp_shellMainNavigationTicketsWaitingForSupplierRoute: typeof AuthApp_shellMainNavigationTicketsWaitingForSupplierRoute
  AuthApp_shellMainNavigationTicketsYoursRoute: typeof AuthApp_shellMainNavigationTicketsYoursRoute
  AuthApp_shellMainNavigationViewViewIdRoute: typeof AuthApp_shellMainNavigationViewViewIdRoute
  AuthApp_shellMainNavigationViewsAddRoute: typeof AuthApp_shellMainNavigationViewsAddRoute
  AuthApp_shellMainNavigationGroupActionsIndexRoute: typeof AuthApp_shellMainNavigationGroupActionsIndexRoute
  AuthApp_shellMainNavigationOrdersIndexRoute: typeof AuthApp_shellMainNavigationOrdersIndexRoute
  AuthApp_shellMainNavigationSearchIndexRoute: typeof AuthApp_shellMainNavigationSearchIndexRoute
  AuthApp_shellMainNavigationViewsIndexRoute: typeof AuthApp_shellMainNavigationViewsIndexRoute
}

const AuthApp_shellMainNavigationRouteChildren: AuthApp_shellMainNavigationRouteChildren =
  {
    AuthApp_shellMainNavigationIndexRoute:
      AuthApp_shellMainNavigationIndexRoute,
    AuthApp_shellMainNavigationContactContactIdRoute:
      AuthApp_shellMainNavigationContactContactIdRoute,
    AuthApp_shellMainNavigationGroupActionGroupActionIdRoute:
      AuthApp_shellMainNavigationGroupActionGroupActionIdRoute,
    AuthApp_shellMainNavigationOrderOrderIdRoute:
      AuthApp_shellMainNavigationOrderOrderIdRoute,
    AuthApp_shellMainNavigationSaleSaleIdRoute:
      AuthApp_shellMainNavigationSaleSaleIdRoute,
    AuthApp_shellMainNavigationTicketsAllRoute:
      AuthApp_shellMainNavigationTicketsAllRoute,
    AuthApp_shellMainNavigationTicketsDoneRoute:
      AuthApp_shellMainNavigationTicketsDoneRoute,
    AuthApp_shellMainNavigationTicketsInvestigatingRoute:
      AuthApp_shellMainNavigationTicketsInvestigatingRoute,
    AuthApp_shellMainNavigationTicketsNeedsFirstResponseRoute:
      AuthApp_shellMainNavigationTicketsNeedsFirstResponseRoute,
    AuthApp_shellMainNavigationTicketsNeedsNextResponseRoute:
      AuthApp_shellMainNavigationTicketsNeedsNextResponseRoute,
    AuthApp_shellMainNavigationTicketsPausedForLaterRoute:
      AuthApp_shellMainNavigationTicketsPausedForLaterRoute,
    AuthApp_shellMainNavigationTicketsSnoozedRoute:
      AuthApp_shellMainNavigationTicketsSnoozedRoute,
    AuthApp_shellMainNavigationTicketsTodoRoute:
      AuthApp_shellMainNavigationTicketsTodoRoute,
    AuthApp_shellMainNavigationTicketsUnassignedRoute:
      AuthApp_shellMainNavigationTicketsUnassignedRoute,
    AuthApp_shellMainNavigationTicketsWaitingForContactRoute:
      AuthApp_shellMainNavigationTicketsWaitingForContactRoute,
    AuthApp_shellMainNavigationTicketsWaitingForSupplierRoute:
      AuthApp_shellMainNavigationTicketsWaitingForSupplierRoute,
    AuthApp_shellMainNavigationTicketsYoursRoute:
      AuthApp_shellMainNavigationTicketsYoursRoute,
    AuthApp_shellMainNavigationViewViewIdRoute:
      AuthApp_shellMainNavigationViewViewIdRoute,
    AuthApp_shellMainNavigationViewsAddRoute:
      AuthApp_shellMainNavigationViewsAddRoute,
    AuthApp_shellMainNavigationGroupActionsIndexRoute:
      AuthApp_shellMainNavigationGroupActionsIndexRoute,
    AuthApp_shellMainNavigationOrdersIndexRoute:
      AuthApp_shellMainNavigationOrdersIndexRoute,
    AuthApp_shellMainNavigationSearchIndexRoute:
      AuthApp_shellMainNavigationSearchIndexRoute,
    AuthApp_shellMainNavigationViewsIndexRoute:
      AuthApp_shellMainNavigationViewsIndexRoute,
  }

const AuthApp_shellMainNavigationRouteWithChildren =
  AuthApp_shellMainNavigationRoute._addFileChildren(
    AuthApp_shellMainNavigationRouteChildren,
  )

interface AuthApp_shellSettingsNavigationRouteChildren {
  AuthApp_shellSettingsNavigationSettingsPreferencesRoute: typeof AuthApp_shellSettingsNavigationSettingsPreferencesRoute
  AuthApp_shellSettingsNavigationSettingsProfileRoute: typeof AuthApp_shellSettingsNavigationSettingsProfileRoute
  AuthApp_shellSettingsNavigationSettingsIndexRoute: typeof AuthApp_shellSettingsNavigationSettingsIndexRoute
  AuthApp_shellSettingsNavigationSettingsMemberMemberIdRoute: typeof AuthApp_shellSettingsNavigationSettingsMemberMemberIdRoute
  AuthApp_shellSettingsNavigationSettingsSnippetTagSnippetTagIdRoute: typeof AuthApp_shellSettingsNavigationSettingsSnippetTagSnippetTagIdRoute
  AuthApp_shellSettingsNavigationSettingsSnippetTagsAddRoute: typeof AuthApp_shellSettingsNavigationSettingsSnippetTagsAddRoute
  AuthApp_shellSettingsNavigationSettingsSnippetSnippetIdRoute: typeof AuthApp_shellSettingsNavigationSettingsSnippetSnippetIdRoute
  AuthApp_shellSettingsNavigationSettingsSnippetsAddRoute: typeof AuthApp_shellSettingsNavigationSettingsSnippetsAddRoute
  AuthApp_shellSettingsNavigationSettingsMembersIndexRoute: typeof AuthApp_shellSettingsNavigationSettingsMembersIndexRoute
  AuthApp_shellSettingsNavigationSettingsSnippetTagsIndexRoute: typeof AuthApp_shellSettingsNavigationSettingsSnippetTagsIndexRoute
  AuthApp_shellSettingsNavigationSettingsSnippetsIndexRoute: typeof AuthApp_shellSettingsNavigationSettingsSnippetsIndexRoute
}

const AuthApp_shellSettingsNavigationRouteChildren: AuthApp_shellSettingsNavigationRouteChildren =
  {
    AuthApp_shellSettingsNavigationSettingsPreferencesRoute:
      AuthApp_shellSettingsNavigationSettingsPreferencesRoute,
    AuthApp_shellSettingsNavigationSettingsProfileRoute:
      AuthApp_shellSettingsNavigationSettingsProfileRoute,
    AuthApp_shellSettingsNavigationSettingsIndexRoute:
      AuthApp_shellSettingsNavigationSettingsIndexRoute,
    AuthApp_shellSettingsNavigationSettingsMemberMemberIdRoute:
      AuthApp_shellSettingsNavigationSettingsMemberMemberIdRoute,
    AuthApp_shellSettingsNavigationSettingsSnippetTagSnippetTagIdRoute:
      AuthApp_shellSettingsNavigationSettingsSnippetTagSnippetTagIdRoute,
    AuthApp_shellSettingsNavigationSettingsSnippetTagsAddRoute:
      AuthApp_shellSettingsNavigationSettingsSnippetTagsAddRoute,
    AuthApp_shellSettingsNavigationSettingsSnippetSnippetIdRoute:
      AuthApp_shellSettingsNavigationSettingsSnippetSnippetIdRoute,
    AuthApp_shellSettingsNavigationSettingsSnippetsAddRoute:
      AuthApp_shellSettingsNavigationSettingsSnippetsAddRoute,
    AuthApp_shellSettingsNavigationSettingsMembersIndexRoute:
      AuthApp_shellSettingsNavigationSettingsMembersIndexRoute,
    AuthApp_shellSettingsNavigationSettingsSnippetTagsIndexRoute:
      AuthApp_shellSettingsNavigationSettingsSnippetTagsIndexRoute,
    AuthApp_shellSettingsNavigationSettingsSnippetsIndexRoute:
      AuthApp_shellSettingsNavigationSettingsSnippetsIndexRoute,
  }

const AuthApp_shellSettingsNavigationRouteWithChildren =
  AuthApp_shellSettingsNavigationRoute._addFileChildren(
    AuthApp_shellSettingsNavigationRouteChildren,
  )

interface AuthApp_shellTicketNavigationRouteChildren {
  AuthApp_shellTicketNavigationTicketTicketIdRoute: typeof AuthApp_shellTicketNavigationTicketTicketIdRoute
}

const AuthApp_shellTicketNavigationRouteChildren: AuthApp_shellTicketNavigationRouteChildren =
  {
    AuthApp_shellTicketNavigationTicketTicketIdRoute:
      AuthApp_shellTicketNavigationTicketTicketIdRoute,
  }

const AuthApp_shellTicketNavigationRouteWithChildren =
  AuthApp_shellTicketNavigationRoute._addFileChildren(
    AuthApp_shellTicketNavigationRouteChildren,
  )

interface AuthApp_shellRouteChildren {
  AuthApp_shellMainNavigationRoute: typeof AuthApp_shellMainNavigationRouteWithChildren
  AuthApp_shellSettingsNavigationRoute: typeof AuthApp_shellSettingsNavigationRouteWithChildren
  AuthApp_shellTicketNavigationRoute: typeof AuthApp_shellTicketNavigationRouteWithChildren
  AuthApp_shellCreateGroupActionRoute: typeof AuthApp_shellCreateGroupActionRoute
}

const AuthApp_shellRouteChildren: AuthApp_shellRouteChildren = {
  AuthApp_shellMainNavigationRoute:
    AuthApp_shellMainNavigationRouteWithChildren,
  AuthApp_shellSettingsNavigationRoute:
    AuthApp_shellSettingsNavigationRouteWithChildren,
  AuthApp_shellTicketNavigationRoute:
    AuthApp_shellTicketNavigationRouteWithChildren,
  AuthApp_shellCreateGroupActionRoute: AuthApp_shellCreateGroupActionRoute,
}

const AuthApp_shellRouteWithChildren = AuthApp_shellRoute._addFileChildren(
  AuthApp_shellRouteChildren,
)

interface AuthRouteChildren {
  AuthApp_shellRoute: typeof AuthApp_shellRouteWithChildren
  AuthAuthRedirectRoute: typeof AuthAuthRedirectRoute
  AuthContactRedirectRoute: typeof AuthContactRedirectRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthApp_shellRoute: AuthApp_shellRouteWithChildren,
  AuthAuthRedirectRoute: AuthAuthRedirectRoute,
  AuthContactRedirectRoute: AuthContactRedirectRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
